// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The principal fields to change. Fields left out keep their value.
 * @export
 * @interface PrincipalUpdateRequest
 */
export interface PrincipalUpdateRequest {
    /**
     * The vendor company id
     * @type {string}
     * @memberof PrincipalUpdateRequest
     */
    company_id?: string;
}

/**
 * Check if a given object implements the PrincipalUpdateRequest interface.
 */
export function instanceOfPrincipalUpdateRequest(value: object): value is PrincipalUpdateRequest {
    return true;
}

export function PrincipalUpdateRequestFromJSON(json: any): PrincipalUpdateRequest {
    return PrincipalUpdateRequestFromJSONTyped(json, false);
}

export function PrincipalUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrincipalUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'company_id': json['company_id'] == null ? undefined : json['company_id'],
    };
}

export function PrincipalUpdateRequestToJSON(json: any): PrincipalUpdateRequest {
    return PrincipalUpdateRequestToJSONTyped(json, false);
}

export function PrincipalUpdateRequestToJSONTyped(value?: PrincipalUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['company_id'],
    };
}
